/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
*/

import { css } from 'styled-components';

const RevxNeue =
  'RevxNeue, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif';
const Playfair =
  'Playfair, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif';

const OPEN_SANS =
  'Open Sans, Nunito Sans, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif';

/* RevxNeue */

export const typeStyleRevxNeueText1 = css`
  font-family: ${RevxNeue};
  font-weight: 100;
  font-size: 1.5rem;
  line-height: 3rem;
`;

export const typeStyleRevxNeueText2 = css`
  font-family: ${RevxNeue};
  font-weight: 200;
  font-size: 4rem;
  line-height: 10.8rem;
`;

export const typeStyleRevxNeueText3 = css`
  font-family: ${RevxNeue};
  font-weight: 300;
  font-size: 3rem;
  line-height: 10.8rem;
`;

export const typeStyleRevxNeueText4 = css`
  font-family: ${RevxNeue};
  font-weight: 300;
  font-size: 3rem;
  font-style: italic;
  line-height: 10.8rem;
`;

export const typeStyleRevxNeueText5 = css`
  font-family: ${RevxNeue};
  font-weight: 500;
  font-size: 3rem;
  line-height: 10.8rem;
`;

export const typeStyleRevxNeueText6 = css`
  font-family: ${RevxNeue};
  font-weight: 600;
  font-size: 3rem;
  line-height: 10.8rem;
`;

export const typeStyleRevxNeueLogoLetter = css`
  font-family: ${RevxNeue};
  font-weight: 600;
  font-size: 4rem;
  line-height: 2.6rem;
  letter-spacing: 0.3rem;
`;

export const typeStyleRevxNeueLogo = css`
  font-family: ${RevxNeue};
  font-weight: 600;
  font-size: 4rem;
  line-height: 2.6rem;
  letter-spacing: -0.15rem;
`;

/* Playfair */

export const typeStylePlayfairText1 = css`
  font-family: ${Playfair};
`;

export const typeStylePlayfairText2 = css`
  font-family: ${Playfair};
`;

/* OpenSans */

export const typeStyleOpenSansText1 = css`
  font-family: ${OPEN_SANS};
  font-weight: 500;
  font-size: 5rem;
  line-height: 10.8rem;
`;

export const typeStyleOpenSansText2 = css`
  font-family: ${OPEN_SANS};
  font-weight: 400;
  font-size: 4rem;
  line-height: 10.8rem;
`;

export const typeStyleOpenSansText3 = css`
  font-family: ${OPEN_SANS};
  font-weight: 300;
  font-size: 3rem;
  line-height: 10.8rem;
`;

export const typeStyleOpenSansText4 = css`
  font-family: ${OPEN_SANS};
  font-weight: 200;
  font-size: 2rem;
  line-height: 10.8rem;
`;

export const typeStyleOpenSansText5 = css`
  font-family: ${OPEN_SANS};
  font-weight: 400;
  font-size: 3rem;
  line-height: 4.5rem;
  letter-spacing: 0.0333333rem;
`;

export const typeStyleOpenSansText6 = css`
  font-family: ${OPEN_SANS};
  font-weight: 600;
  font-size: 2.4rem;
  line-height: 3.6rem;
  letter-spacing: 0.025rem;
`;

export const typeStyleOpenSansText7 = css`
  font-family: ${OPEN_SANS};
  font-weight: 200;
  font-size: 1rem;
  line-height: 0.8rem;
`;

export const typeStyleOpenSansText8 = css`
  font-family: ${OPEN_SANS};
  font-weight: 400;
  font-size: 1.3rem;
  line-height: 1rem;
`;
